import { useEffect } from "react";
import { ORIGIN_PARAM_NAME } from "src/constants/UrlConstants";
import { ROUTE_PATHS } from "src/utils/constants";
import { getValueCookie } from "src/utils/cookies";
import { removeEntryOriginInSession } from "src/utils/init/configuration";
import { useNavigationHistory } from "src/utils/providers/NavigationHistoryProvider";

export const useOriginMonitor = () => {
  const originInCookies = getValueCookie(ORIGIN_PARAM_NAME);
  const { previousPage, currentPage } = useNavigationHistory();

  const pathsToMonitor = [ROUTE_PATHS.CART, ROUTE_PATHS.CHECKOUT];

  const isMonitoredPath = (path) => {
    return pathsToMonitor.some((monitoredPath) =>
      path?.includes(monitoredPath),
    );
  };

  useEffect(() => {
    if (!originInCookies) return;

    const wasInMonitoredPath = isMonitoredPath(previousPage);
    const isInNonMonitoredPath = !isMonitoredPath(currentPage);

    if (wasInMonitoredPath && isInNonMonitoredPath) {
      removeEntryOriginInSession();
    }
  }, [previousPage, currentPage, originInCookies]);

  useEffect(() => {
    if (!originInCookies) return;

    if (!isMonitoredPath(currentPage)) {
      removeEntryOriginInSession();
    }
  }, []);
};
